// extracted by mini-css-extract-plugin
var _1 = "ApplicantProfileWidgetStageScreeningRow-moduleApplicantProfileWidgetStageScreeningRow__SedSI";
var _2 = "ApplicantProfileWidgetStageScreeningRow-modulecontent__iAJ6f";
var _3 = "ApplicantProfileWidgetStageScreeningRow-modulecontentLast__DeU2j";
var _4 = "ApplicantProfileWidgetStageScreeningRow-modulelabel__qyxil";
export { _1 as "ApplicantProfileWidgetStageScreeningRow", _2 as "content", _3 as "contentLast", _4 as "label" }
